// extracted by mini-css-extract-plugin
export default {"paymentSection":"c5-z"};